import { normalizeOfferingProps } from "features/Listings/modules/ShareListingPopup/utils/ShareListingPopup.utils";
import { isInternationalTimezone } from "utils/AuthUtil";
import { INR } from "features/Listings/Listings.constants";
import constants from "constants/constants";

/**
 * Checks if a given currency represents INR/domestic Indian Rupee currency (INR, ₹, RS, 1, or default empty).
 *
 * @param {any} rawCurrency
 * @returns {boolean} True if currency is INR or default empty domestic currency.
 */
export const checkIsInrCurrency = (rawCurrency) => {
  if (rawCurrency === undefined || rawCurrency === null || rawCurrency === "") {
    return true;
  }
  const str = String(rawCurrency).toUpperCase().trim();
  if (!str) return true;
  return str === INR || str === constants.inr_currency;
};

/**
 * Determines whether QR Code modal/action is eligible to be displayed for an offering.
 *
 * @param {Object} props - Offering props or offering object
 * @returns {boolean} True if QR Code generator should be hidden, false if eligible/shown.
 */
export const isQrEligible = (props = {}) => {
  const isInternationalTimeZone = isInternationalTimezone();
  const normalizedOffering = normalizeOfferingProps(props);

  const rawCurrency =
    normalizedOffering.currency ||
    props?.currency ||
    props?.currency_name ||
    props?.offeringData?.currency ||
    props?.offeringData?.currency_name ||
    "";

  const isNonInrCurrency = !checkIsInrCurrency(rawCurrency);

  const shouldHideQr =
    normalizedOffering.isFlexible ||
    (normalizedOffering.isTrafficAnalysis &&
      !normalizedOffering.hasListingId) ||
    normalizedOffering.isPlan ||
    normalizedOffering.isMerchandiseWithVariants ||
    isInternationalTimeZone ||
    normalizedOffering.isZeroPrice ||
    isNonInrCurrency;

  return !shouldHideQr;
};

export const checkShouldHideQr = (props = {}) => !isQrEligible(props);
